var lastScrollTop = 0;

// Polyfill IE11
if ('NodeList' in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // --- MOBILE SELECT FUNCTION ---
    function convertSubmenuToCustomSelect() {
        if (window.innerWidth <= 640) {
            const submenuHold = document.querySelector(".sub-menu__hold .sub-menu");
            if (!submenuHold) return;

            const originalUl = submenuHold.querySelector("ul");
            if (!originalUl || submenuHold.querySelector('.custom-submenu-trigger')) return;

            const activeLink = originalUl.querySelector("a.active") || originalUl.querySelector("a");
            const activeText = activeLink ? activeLink.textContent.trim() : "Select Menu";
            
            const customSelectWrapper = document.createElement("div");
            customSelectWrapper.className = "custom-submenu-select";
            
            const trigger = document.createElement("div");
            trigger.className = "custom-submenu-trigger";
            trigger.innerHTML = `<span>${activeText}</span> <i class="arrow"></i>`;
            
            originalUl.classList.add("custom-submenu-list");
            
            originalUl.parentNode.insertBefore(customSelectWrapper, originalUl);
            customSelectWrapper.appendChild(trigger);
            customSelectWrapper.appendChild(originalUl);
            
            trigger.addEventListener("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                customSelectWrapper.classList.toggle("is-open");
            });

            const menuLinks = originalUl.querySelectorAll('a');
            menuLinks.forEach(function(link) {
                link.addEventListener('click', function() {
                    customSelectWrapper.classList.remove('is-open');
                    trigger.querySelector('span').textContent = this.textContent;
                });
            });

            document.addEventListener("click", function() {
                customSelectWrapper.classList.remove("is-open");
            });
        }
    }

    document.addEventListener("DOMContentLoaded", convertSubmenuToCustomSelect);

    if(document.querySelectorAll('.js-accordion-trigger').length > 0){
        document.querySelectorAll('.js-accordion-trigger').forEach( tab=> {
            tab.addEventListener('click', () => {
                tab.setAttribute('aria-expanded', tab.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
            })
    
        });
    }

    window.onload = function() {
        convertSubmenuToCustomSelect();

        const subMenuHold = document.querySelector('.sub-menu__hold');
        const introContent = document.querySelector('.intro-content');
        if (subMenuHold && introContent) {
            introContent.classList.add('with-submenu');
        }

        scrollW();
        window.addEventListener('scroll', function() {
            scrollW();
            const homeSection = document.getElementById('home');
            const scrollPosition = window.scrollY;
            const viewportHeight = window.innerHeight;

            if (homeSection) {
                if (scrollPosition >= viewportHeight) {
                    homeSection.classList.add('is-fixed');
                } else {
                    homeSection.classList.remove('is-fixed');
                }
            }
        });

        // Email signup animation 
        if(document.getElementById('email-signup')){
            const signupFields = ['email-signup_FNAME', 'email-signup_LNAME', 'email-signup_email_address'];
            signupFields.forEach(function(id) {
                const el = document.getElementById(id);
                if(el) el.addEventListener('focus', function(){ this.parentElement.classList.add('moved'); });
            });
        }

        // CMS forms label animation
        const formFields = document.getElementsByClassName('form-module__field');
        if(formFields.length > 0){
            Array.from(formFields).forEach(function(field) {
                const inputs = field.querySelectorAll('input:not([type="checkbox"]):not([type="radio"]), select, textarea');
                inputs.forEach(function(input) {
                    input.addEventListener('focus', function(){ this.parentElement.classList.add('moved'); });
                });
            });
        }

        // Parallax
        const parallaxImages = document.querySelectorAll('#home figure img:not(.no-parallax), #default figure img:not(.no-parallax), .parallax');
        function initializeParallax() {
            if (typeof Ukiyo !== 'undefined' && parallaxImages.length > 0) {
                Array.from(parallaxImages).forEach(function(img) {
                    new Ukiyo(img, { scale: 1, speed: 1.7, willChange: true });
                });
            }
        }
        initializeParallax();

        // Header Observer
        (function observeHeaderChanges() {
            const header = document.getElementById("header");
            const hold = document.querySelector(".sub-menu__hold");
            if (!header || !hold) return;

            function updateSubmenuPosition() {
                if (header.classList.contains("not-image")) {
                    hold.style.position = "fixed";
                    hold.style.top = header.offsetHeight + "px";
                } else {
                    hold.style.position = ""; hold.style.top = "";
                }
            }
            updateSubmenuPosition();
            const observer = new MutationObserver(updateSubmenuPosition);
            observer.observe(header, { attributes: true, attributeFilter: ['class'] });
            window.addEventListener('resize', updateSubmenuPosition);
        })();

        // Mobile Menu
        const menuContainer = document.getElementById('menu-container') || document.getElementById('js-menuContainer');
        if(menuContainer){
            const openBtn = document.querySelector('.js-open-menu') || document.querySelector('#js-burgerMenuBtn');
            const closeBtn = document.querySelector('.js-close-menu') || document.querySelector('.js-burger-close');
            
            const linksMenu = menuContainer.querySelectorAll('a');
            linksMenu.forEach(function(link) {
                link.addEventListener('mouseenter', function() {
                    const match = this.className.match(/img-([^\s]+)/);
                    if (match) {
                        const target = match[1].replace('active', '').trim();
                        document.querySelectorAll('.menu__images img').forEach(function(img) {
                            img.classList.toggle('active', img.dataset.image === target);
                        });
                    }
                });
            });

            const toggleMenu = function(open) {
                menuContainer.classList.toggle('show', open);
                menuContainer.classList.toggle('open', open);
                document.body.classList.toggle("no-scroll", open);
            };

            if(openBtn) openBtn.addEventListener('click', function(e) { e.preventDefault(); toggleMenu(true); });
            if(closeBtn) closeBtn.addEventListener('click', function(e) { e.preventDefault(); toggleMenu(false); });
        }

        window.addEventListener('resize', function() {
            convertSubmenuToCustomSelect();
        });
    };

    document.querySelectorAll('p').forEach(function(p) {
        if(p.innerHTML.trim() === '') p.remove();
    });
})();

function scrollW(){
    const header = document.getElementById('header');
    if(!header) return;
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if(st > 80){
        header.classList.toggle('down', st > lastScrollTop);
        header.classList.toggle('up', st <= lastScrollTop);
    } else {
        header.classList.remove('up', 'down');
    }
    lastScrollTop = st <= 0 ? 0 : st;
}